import React from 'react';

import svg from './assets/icons-16-plus.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconPlus = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-plus" />;
